import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useI18n, LANGS } from "../lib/i18n.jsx";
import { PageHeader } from "../components/Bits";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { toast } from "sonner";

export default function Settings() {
  const { t } = useI18n();
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/settings").then((r) => setS(r.data)); }, []);
  const save = async () => {
    try { await api.put("/settings", s); toast.success(t("save")); }
    catch (e) { toast.error(e.response?.data?.detail || t("error")); }
  };
  if (!s) return null;
  return (
    <div className="max-w-xl">
      <PageHeader title={t("settings")} subtitle={t("branding_company")} />
      <div className="tactical-card p-5 space-y-4">
        <Field label={t("company_name")}><Input value={s.name || ""} onChange={(e) => setS({ ...s, name: e.target.value })} data-testid="set-name" /></Field>
        <Field label={t("app_name")}><Input value={s.app_name || ""} onChange={(e) => setS({ ...s, app_name: e.target.value })} data-testid="set-app" /></Field>
        <Field label="Logo URL"><Input value={s.logo_url || ""} onChange={(e) => setS({ ...s, logo_url: e.target.value })} data-testid="set-logo" /></Field>
        <Field label={t("primary_color")}>
          <div className="flex items-center gap-2">
            <input type="color" value={s.primary_color || "#D97706"} onChange={(e) => setS({ ...s, primary_color: e.target.value })} className="h-9 w-14" data-testid="set-color" />
            <Input value={s.primary_color || ""} onChange={(e) => setS({ ...s, primary_color: e.target.value })} />
          </div>
        </Field>
        <Field label={t("default_language")}>
          <select className="border rounded-md h-10 px-2 text-sm w-full" value={s.default_language} onChange={(e) => setS({ ...s, default_language: e.target.value })} data-testid="set-lang">
            {LANGS.map((l) => <option key={l.code} value={l.code}>{l.flag} {l.name}</option>)}
          </select>
        </Field>
        <Field label={t("pdf_footer")}><Textarea value={s.pdf_footer || ""} onChange={(e) => setS({ ...s, pdf_footer: e.target.value })} data-testid="set-footer" /></Field>
        <Button onClick={save} className="bg-[var(--amber)] hover:bg-[var(--amber-2)] text-white" data-testid="settings-save">{t("save")}</Button>
      </div>
    </div>
  );
}
function Field({ label, children }) {
  return <div><label className="text-xs uppercase font-semibold text-[var(--text-3)] mb-1 block">{label}</label>{children}</div>;
}
